import * as Yup from 'yup'
import _get from 'lodash.get'
import _set from 'lodash.set'

export function yupToFormErrors(yupError) {
  let errors = {}
  if (yupError.inner) {
    if (yupError.inner.length === 0) {
      return _set(errors, yupError.path, yupError.message)
    }
    for (const err of yupError.inner) {
      if (!_get(errors, err.path)) {
        errors = _set(errors, err.path, err.message)
      }
    }
  }
  return errors
}

export const validateSchema = async (schema, value) => {
  try {
    await schema.validate(value, { abortEarly: false })
  } catch (error) {
    if (error.name === 'ValidationError') {
      return {
        errors: yupToFormErrors(error)
      }
    }
  }
  return { errors: {} }
}

export const emailSchema = Yup.string()
  .email('Please enter valid email')
  .required()
